import React from "react";
import axios from '../../axios/axiosconf'
import { debeFiltrarPorProfesional } from '../../../utils/userAccessHelpers';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import ModalResumen from "./ModalResumen";
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha, getFechaActual } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";

function ModalContraremisiones(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    const [remitidoA, setRemitidoA] = useState('');
    const [direccion, setDireccion] = useState('');
    const [telefono, setTelefono] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [fecha, setFecha] = useState(getFechaActual());

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirmaRemitente, setTextoPieFirmaRemitente] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // Estados para controlar modales con React (como en ModalRemisiones.js)
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);
    const [pdfNativoConfigIndividual, setPdfNativoConfigIndividual] = useState(null);
    const [pdfNativoConfigConsolidado, setPdfNativoConfigConsolidado] = useState(null);

    const [listaProfesionales, setListaProfesionales] = useState([]);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        /*axios.get('/perfil', config)
            .then(response => {
                if (response.status===200) {
                    
                    setNombreProfesional(response.data.name+' '+response.data.lastname);
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma);
                }
            })
            .catch(error => {
                console.log(error);
            });*/

        axios.get('/profesionales-atencion-pacientes', config)
            .then(response => {
                if (response.status === 200) {
                    setListaProfesionales(response.data);
                }
            })
            .catch(error => console.log(error.response.data))

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    const nombrePacienteDesdeItemContraremision = (item) => {
        const sn = item.segundo_nombre ? `${item.segundo_nombre} ` : '';
        const sa = item.segundo_apellido ? item.segundo_apellido : '';
        return `${item.primer_nombre || ''} ${sn}${item.primer_apellido || ''} ${sa}`.trim() || 'Paciente no identificado';
    };

    const documentoDesdeItemContraremision = (item) => {
        const t = item.tipo_documento || '';
        const n = item.numero_documento || '';
        if (t && n) return `${t} - ${n}`;
        return n || t || '—';
    };

    const valorNoAplica = (valor, fallback = 'No aplica') => {
        if (valor === null || valor === undefined) return fallback;
        const s = String(valor).trim();
        if (!s) return fallback;
        const lower = s.toLowerCase();
        if (lower === 'null' || lower === 'undefined') return fallback;
        return s;
    };

    const estilosTablaPdfGris = () => {
        const gris = [248, 249, 250];
        return {
            bodyStyles: { fillColor: gris },
            alternateRowStyles: { fillColor: gris },
            columnStyles: {
                0: { cellWidth: 52, fontStyle: 'bold', fillColor: gris },
                1: { cellWidth: 'auto', fillColor: gris },
            },
        };
    };

    /** Misma presentación que Otros Documentos / Exámenes: separador + firma sin banda gris. */
    const htmlFirmaProfesionalDesdeItem = (item) => {
        const firmaSrc = item.firma_final || item.firma;
        if (!item.profesional || !firmaSrc) return '';
        const pieFirmaHtml = item.texto_pie_firma_usuario
            ? `<div style="font-size: 13px; color: #6c757d; line-height: 1.45; white-space: pre-line;">${item.texto_pie_firma_usuario}</div>`
            : `<div style="font-size: 13px; color: #6c757d; line-height: 1.45;">
                    <strong>${item.profesional}</strong><br/>
                    RM: ${valorNoAplica(item.registro_medico)} | Habilitación: ${valorNoAplica(item.codigo_habilitacion)}
                  </div>`;
        return `
                <div style="height: 1px; background-color: #e9ecef; margin: 24px 0; width: 100%;" role="presentation" aria-hidden="true"></div>
                <div style="margin-top: 0; margin-bottom: 28px; padding-left: 12px; page-break-inside: avoid;">
                    <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase; font-size: 13px; color: #212529;">
                        Firma del profesional
                    </div>
                    <div style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 14px;">
                        <div style="flex: 1; min-width: 160px;">${pieFirmaHtml}</div>
                        <div style="flex-shrink: 0;">
                            <img src="${firmaSrc}" alt="" style="max-width: 180px; max-height: 90px; display: block;" />
                        </div>
                    </div>
                </div>`;
    };

    /** Vista previa / consolidado: una sola tabla gris con columna de etiqueta fija. */
    const construirHtmlCuerpoContraremisionItem = (item) => {
        const nombrePaciente = nombrePacienteDesdeItemContraremision(item);
        const documento = documentoDesdeItemContraremision(item);
        const celdaEtiqueta = 'background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;';
        const celdaValor = 'background-color: #f8f9fa; padding: 8px 12px; border: 1px solid #dee2e6;';

        const tablaUnificada = `
            <div style="margin-bottom: 14px;">
                <table style="width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 13px; border: 1px solid #dee2e6;">
                    <colgroup>
                        <col style="width: 28%;" />
                        <col style="width: 72%;" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td style="${celdaEtiqueta}">PACIENTE</td>
                            <td style="${celdaValor}">${nombrePaciente}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">DOCUMENTO</td>
                            <td style="${celdaValor}">${documento}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">FECHA Y HORA</td>
                            <td style="${celdaValor}">${item.fecha || ''}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">REMITIDO A</td>
                            <td style="${celdaValor}">${item.remitido_a || ''}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">ESPECIALIDAD</td>
                            <td style="${celdaValor}">${item.especialidad || 'No especificada'}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">DIRECCIÓN</td>
                            <td style="${celdaValor}">${item.direccion || 'No especificada'}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">TELÉFONO</td>
                            <td style="${celdaValor}">${item.telefono || 'No especificado'}</td>
                        </tr>
                        <tr>
                            <td style="${celdaEtiqueta}">REMITIDO POR</td>
                            <td style="${celdaValor} font-weight: bold; color: #325e68;">${item.profesional || ''}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        const tituloCentrado = `
            <div style="margin: 8px 0 14px; text-align: center; font-weight: bold; font-size: 15px; color: #212529; letter-spacing: 0.02em;">
                CONTRAREMISIÓN MÉDICA
            </div>`;

        const descHtml = (item.descripcion && String(item.descripcion).trim())
            ? item.descripcion
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin descripción</p>';

        const bloqueDescripcion = `
            <div style="height: 1px; background-color: #e9ecef; margin: 18px 0 14px; width: 100%;" role="presentation" aria-hidden="true"></div>
            <div style="margin-bottom: 12px;">
                <div style="font-weight: 700; margin-bottom: 8px; text-transform: uppercase; font-size: 13px; color: #212529;">
                    Descripción
                </div>
                <div style="font-size: 13px; line-height: 1.45;">${descHtml}</div>
            </div>`;

        return tituloCentrado + tablaUnificada + bloqueDescripcion + htmlFirmaProfesionalDesdeItem({
            ...item,
            firma_final: item.firma_final || item.firma
        });
    };

    const construirHtmlVistaContraremisionNativa = (item) => {
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        return encabezadoPrev +
            '<div style="font-family: sans-serif; color: #212529;">' +
            construirHtmlCuerpoContraremisionItem(item) +
            '</div>';
    };

    const construirHtmlConsolidadoContraremisiones = (items) => {
        if (!Array.isArray(items) || items.length === 0) return '';
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        const titulo = `
            <div style="margin: 0 0 16px; text-align: center; font-weight: bold; font-size: 15px; color: #212529;">
                HISTORIAL DE CONTRAREMISIONES
            </div>`;
        let bloques = '';
        items.forEach((item, i) => {
            if (i > 0) {
                bloques += '<div style="height: 1px; background-color: #e9ecef; margin: 24px 0; width: 100%;"></div>';
            }
            bloques += `<div style="page-break-inside: avoid;">${construirHtmlCuerpoContraremisionItem(item)}</div>`;
        });
        return encabezadoPrev +
            '<div style="font-family: sans-serif; color: #212529;">' +
            titulo +
            bloques +
            '</div>';
    };

    const rellenarSeccionesPdfContraremisionItem = (secciones, item, { incluirPaciente = true } = {}) => {
        const filasMeta = [];
        if (incluirPaciente) {
            filasMeta.push({ etiqueta: 'PACIENTE', valor: nombrePacienteDesdeItemContraremision(item) });
            filasMeta.push({ etiqueta: 'DOCUMENTO', valor: documentoDesdeItemContraremision(item) });
        }
        filasMeta.push({ etiqueta: 'FECHA Y HORA', valor: String(item.fecha || '') });
        filasMeta.push({ etiqueta: 'REMITIDO A', valor: String(item.remitido_a || '') });
        filasMeta.push({ etiqueta: 'ESPECIALIDAD', valor: String(item.especialidad || 'No especificada') });
        filasMeta.push({ etiqueta: 'DIRECCIÓN', valor: String(item.direccion || 'No especificada') });
        filasMeta.push({ etiqueta: 'TELÉFONO', valor: String(item.telefono || 'No especificado') });
        filasMeta.push({ etiqueta: 'REMITIDO POR', valor: String(item.profesional || '') });

        secciones.push({
            tipo: 'subtitulo',
            contenido: 'CONTRAREMISIÓN MÉDICA',
            estilos: {
                alineacion: 'center',
                fontSize: 12,
                margenSuperiorMm: 2,
                espacioDespuesMm: 6,
            },
        });

        secciones.push({
            tipo: 'tabla-datos',
            datos: { filas: filasMeta },
            estilos: estilosTablaPdfGris(),
        });

        const descHtml = (item.descripcion && String(item.descripcion).trim())
            ? item.descripcion
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin descripción</p>';

        secciones.push({
            tipo: 'texto',
            titulo: 'DESCRIPCIÓN',
            contenido: descHtml,
            estilos: { margenSuperiorMm: 4 },
        });

        const firmaSrc = item.firma_final || item.firma;
        if (firmaSrc && item.profesional) {
            const metaPdf = item.texto_pie_firma_usuario
                ? { tipo: 'profesional', textoPieFirma: item.texto_pie_firma_usuario }
                : {
                    tipo: 'profesional',
                    nombre: item.profesional || '',
                    registroMedico: valorNoAplica(item.registro_medico),
                    codigoHabilitacion: valorNoAplica(item.codigo_habilitacion)
                  };
            secciones.push({
                tipo: 'firma',
                imagenBase64: firmaSrc,
                metadata: metaPdf,
                estilos: {
                    estiloEvolucion: true,
                    separadorPrevia: true,
                    margenSuperiorMm: 4,
                },
            });
        }
    };

    const construirConfigPdfContraremisionNativo = (item) => {
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';
        const config = {
            filename: `contraremision-${slug}.pdf`,
            paciente: {
                nombreCompleto: nombrePacienteDesdeItemContraremision(item),
                documentoCompleto: documentoDesdeItemContraremision(item)
            },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };
        rellenarSeccionesPdfContraremisionItem(config.secciones, item, { incluirPaciente: true });
        return config;
    };

    const construirConfigPdfContraremisionesConsolidadoNativo = () => {
        if (!historial || historial.length === 0) return null;
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';
        const config = {
            filename: `contraremisiones-consolidado-${slug}.pdf`,
            paciente: {
                nombreCompleto: nombrePacienteDesdeItemContraremision(historial[0]),
                documentoCompleto: documentoDesdeItemContraremision(historial[0])
            },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            omitTablaPacienteInicial: true,
            secciones: []
        };
        config.secciones.push({
            tipo: 'subtitulo',
            contenido: 'HISTORIAL DE CONTRAREMISIONES',
            estilos: {
                alineacion: 'center',
                fontSize: 13,
                margenSuperiorMm: 0,
                espacioDespuesMm: 8,
            },
        });
        historial.forEach((it, index) => {
            if (index > 0) config.secciones.push({ tipo: 'salto-pagina' });
            rellenarSeccionesPdfContraremisionItem(config.secciones, it, { incluirPaciente: true });
        });
        return config;
    };

    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: paciente_id
            }
        }

        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/contraremisiones', config2)
            .then(response => {
                const lista = Array.isArray(response.data) ? response.data : [];
                setHistorial(lista);
                try {
                    setConsolidado(construirHtmlConsolidadoContraremisiones(lista));
                } catch (e) {
                    console.error('Error generando consolidado contraremisiones:', e);
                    setConsolidado('');
                }
            })
            .catch(error => {
                console.log(error);
                setHistorial([]);
                setConsolidado('');
            });
    }




    const handleSubmit = (e) => {

        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            client_id: client.client_id,
            remitido_por: nombreProfesional,
            registro_medico: valorNoAplica(registroMedico),
            codigo_habilitacion: valorNoAplica(codigoHabilitacion),
            remitido_a: remitidoA,
            direccion: direccion,
            telefono: telefono,
            especialidad: especialidad,
            descripcion: descripcion,
            user_id: userdata.user_id,
            fecha: fecha
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        axios.post('contraremision', data, config)
            .then(() => {
                setLoading(false);
                setDeshabilitarBotonGuardar(true);
                setRemitidoA('');
                setDireccion('');
                setTelefono('');
                setEspecialidad('');
                setDescripcion('');
                const sel = document.getElementById('remitidoPor');
                if (sel) sel.value = '';
                setErrorlist({});
                cargaritems();
                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                console.log('Error guardando contraremisión:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                    const d = error.response && error.response.data ? error.response.data : null;
                    const msg = (d && (d.message || d.error)) || error.message || 'No se pudo guardar la contraremisión.';
                    alert(msg);
                }
            })

    }

    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        setDeshabilitarBotonGuardar(false);
        props.guardarCambios('La contraremisión ha sido guardada exitosamente');
    };


    const verResumen = (ttlResumen, resumenIndividual) => {
        setTituloResumen(ttlResumen);
        setPdfNativoConfigIndividual(construirConfigPdfContraremisionNativo(resumenIndividual));
        setContenidoResumenIndividual(construirHtmlVistaContraremisionNativa(resumenIndividual));
        setShowModalResumen(true);
    }


    useEffect(() => {
        cargaritems();

        // Cleanup function to prevent memory leaks
        return () => {
            setHistorial([]);
            setConsolidado('');
            setShowModalResumen(false);
            setShowModalConsolidado(false);
            setPdfNativoConfigIndividual(null);
            setPdfNativoConfigConsolidado(null);
        };
    }, [props.cargarHistorial]);


    const handleProfesionalContraremision = (profesionalContraremision) => {
        if (!profesionalContraremision) {
            setNombreProfesional('');
            setRegistroMedico('');
            setCodigoHabilitacion('');
            setFirmaimg('');
            setTextoPieFirmaRemitente('');
            return;
        }

        for (let prof of listaProfesionales) {
            if (profesionalContraremision == prof.id) {
                setNombreProfesional(prof.name + ' ' + prof.lastname);
                setRegistroMedico(prof.registro_medico ?? '');
                setCodigoHabilitacion(prof.codigo_habilitacion ?? '');
                setFirmaimg(prof.firma_blob || '');
                setTextoPieFirmaRemitente(prof.texto_pie_firma || '');
                break;
            }
        }
    }


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `contraremisiones-consolidado-${props.docPaciente || 'paciente'}.pdf`,
            image: { type: 'jpeg', quality: 0.97 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        // 🆕 Usar encabezado personalizado si está disponible, eliminar información duplicada del paciente
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // 🔧 ELIMINADA información duplicada del paciente (anamnesis) como en ModalEvolucion.js
        let contraremisionCompleta = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif;">' +
            '<h1 style="text-align: center; margin-bottom: 20px;">CONTRAREMISIONES</h1>' +
            consolidado +
            '</div>';

        html2pdf(contraremisionCompleta, opt);
    }


    if (loggedIn) {
        return (

            <>

                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="fecha">Fecha *</label>
                                                    <input type="date" name="fecha" className="form-control" id="fecha" value={fecha} required onChange={(e) => setFecha(e.target.value)} />
                                                    {errorlist.fecha && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.fecha}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="remitidoPor">Remitido por *</label>
                                                    <select name="remitidoPor" className="form-control" id="remitidoPor" required onChange={(e) => handleProfesionalContraremision(e.target.value)}>
                                                        <option value="">Seleccione profesional...</option>
                                                        {
                                                            listaProfesionales.map((prof) =>

                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            )
                                                        }
                                                    </select>
                                                    {errorlist.remitido_por && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.remitido_por}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="remitidoA">Remitido a *</label>
                                                    <input type="text" name="remitido-a" className="form-control" id="remitidoA" required value={remitidoA} onChange={(e) => setRemitidoA(e.target.value)} />
                                                    {errorlist.remitido_a && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.remitido_a}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="telefono">Teléfono</label>
                                                    <input type="text" name="telefono" className="form-control" id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input type="text" name="direccion" className="form-control" id="direccion" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="especialidad">Especialidad</label>
                                                    <input type="text" name="especialidad" className="form-control" id="especialidad" value={especialidad} onChange={(e) => setEspecialidad(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="descripcion">Descripción *</label>
                                                    <textarea
                                                        name="descripcion"
                                                        className="form-control"
                                                        id="descripcion"
                                                        rows="4"
                                                        required
                                                        value={descripcion}
                                                        onChange={(e) => setDescripcion(e.target.value)}
                                                        placeholder="Ingrese la descripción de la contraremisión..."
                                                    />
                                                    {errorlist.descripcion && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.descripcion}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card" style={{ marginTop: '12px' }}>
                                        <div className="card-body" style={{ padding: '0.7rem' }}>
                                            <div className="row">
                                                {firmaimg && (
                                                    <div className="col-md-4">
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label>Firma del profesional (remitente)</label>
                                                            <br />
                                                            <img src={firmaimg} className="firma-profesional-hc" alt="" />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className={firmaimg ? 'col-md-8' : 'col-md-12'}>
                                                    <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                        <label>Pie de firma</label>
                                                        <br />
                                                        {textoPieFirmaRemitente ? (
                                                            <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                {textoPieFirmaRemitente}
                                                            </div>
                                                        ) : (
                                                            <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>
                                                                {nombreProfesional || 'Seleccione profesional en “Remitido por”'}
                                                                <br />
                                                                <small>
                                                                    RM: {valorNoAplica(registroMedico)} | Hab: {valorNoAplica(codigoHabilitacion)}
                                                                </small>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-secondary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <button type="button" className="btn btn-outline-secondary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div className="col-md-3">



                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de Contraremisiones</b>

                                    {
                                        historial.map((item) =>

                                            <div key={item.id} className="timeline-item-container" onClick={() => verResumen('Contraremisión', item)}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button type="button" className="btn btn-sm btn-dark btn-resumen-historico" onClick={() => {
                                    setPdfNativoConfigConsolidado(construirConfigPdfContraremisionesConsolidadoNativo());
                                    setShowModalConsolidado(true);
                                }}>Ver todo</button>
                                {/*<br />
                                        <button className="btn btn-primary btn-resumen-historico" onClick={descargarPdf}>Descargar</button>*/}

                            </div>
                        </div>

                    </div>
                </section>

                {showModalResumen && (
                    <ModalResumenRemision
                        idModal="modalResumenContraremisiones"
                        titulo={tituloResumen}
                        contenido={contenidoResumenIndividual}
                        profesional={profesionalResumenIndividual}
                        registro={registroMedicoResumenIndividual}
                        codigo={codigoHabilitacionResumenIndividual}
                        firma={firmaResumenIndividual}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo={'contraremision'}
                        docPaciente={props.docPaciente}
                        cliente={client}
                        pdfNativoConfig={pdfNativoConfigIndividual}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        onClose={() => {
                            setShowModalResumen(false);
                            setPdfNativoConfigIndividual(null);
                        }}
                    />
                )}

                {showModalConsolidado && (
                    <ModalResumenRemision
                        idModal="modalConsolidadoContraremisiones"
                        titulo="Resumen contraremisiones"
                        contenido={consolidado}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo={'historico-contraremisiones'}
                        docPaciente={props.docPaciente}
                        cliente={client}
                        pdfNativoConfig={pdfNativoConfigConsolidado}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        onClose={() => {
                            setShowModalConsolidado(false);
                            setPdfNativoConfigConsolidado(null);
                        }}
                    />
                )}

                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-file-medical mr-1"></i> Contraremisión Guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-0" style={{ fontSize: '16px' }}>
                            La Contraremisión ha sido Guardada Exitosamente. Puede abrirla desde el Historial para Vista Previa o PDF.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalContraremisiones;